import { ITravelCarHireSubBooking } from '@shared/shared/interfaces/travel-car-hire.interfaces';
import * as fromActions from '../actions/travel-car-hire-sub-booking.actions';

export const initialState: ITravelCarHireSubBooking = {
  url: '',
  car_hire_extras: [],
  car_hire_sub_booking_id: null,
  id: null,
  search_result: '',
  pay_local_selected: false,
  total_price: '',
  total_price_currency: '',
  terms_and_conditions: null,
  terms_and_conditions_url: '',
  terms: {
    links: [],
    popups: [],
    text: [],
  },
  car_type: [''],
  lead_driver: { full_name: '' },
  price_per_day: 0,
  supplier_name: '',
  drop_off: null,
  pick_up: null,
  installments: null,
  travellerPatch: {
    loading: false,
    loaded: false,
    error: null,
  },
};

export function reducer(
  state = initialState,
  action: fromActions.TravelCarHireSubBookingActions
): ITravelCarHireSubBooking {
  switch (action.type) {
    case fromActions.CLEAR_CAR_SUB_BOOKING:
      return initialState;

    case fromActions.VIEW_CAR_SUB_BOOKING_SUCCESS:
    case fromActions.CREATE_CAR_SUB_BOOKING_SUCCESS:
    case fromActions.RESTORE_CAR_HIRE_SUB_BOOKING_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
      };

    case fromActions.CREATE_CAR_SUB_BOOKING_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case fromActions.PATCH_CAR_SUB_BOOKING_TRAVELLERS:
      return {
        ...state,
        travellerPatch: {
          loading: true,
          loaded: false,
          error: null,
        },
      };
    case fromActions.PATCH_CAR_SUB_BOOKING_TRAVELLERS_SUCCESS:
      return {
        ...state,
        lead_driver: action.payload.lead_driver,
        travellerPatch: {
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case fromActions.PATCH_CAR_SUB_BOOKING_TRAVELLERS_FAILURE:
      return {
        ...state,
        travellerPatch: {
          loading: false,
          loaded: false,
          error: action.payload,
        },
      };
    case fromActions.CLEAR_CAR_TRAVELLER_PATCH:
      return {
        ...state,
        travellerPatch: {
          loading: false,
          loaded: false,
          error: null,
        },
      };
    default:
      return state;
  }
}
